// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media  screen and (max-width:640px) {\n.padMobile[data-v-325cc717]{\n    padding-top: 18px ;\n}\n}\n", ""]);
// Exports
module.exports = exports;
